@if (data()?.Description || isNewTransfer()) {
  <iu-storekeeper-input
    [label]="'Description' | SKWTranslate"
    [placeholder]="'NoDescription' | SKWTranslate"
    [readOnly]="!isNewTransfer()"
    [type]="'textarea'"
    [value]="data()?.Description ?? ''"
    (valueChange)="changeValue('Description', $event)" />
}

@if (data()?.Comment || isNewTransfer()) {
  <iu-storekeeper-input
    [label]="'comment' | SKWTranslate"
    [readOnly]="!isNewTransfer()"
    [type]="'textarea'"
    [value]="data()?.Comment ?? ''"
    (valueChange)="changeValue('Comment', $event)" />
}

@if (isConditioning()) {
  <div class="column">
    <span>{{ 'Destination' | SKWTranslate }}</span>
    <div class="row">
      <iu-storekeeper-input
        class="flex"
        [label]="'Location' | SKWTranslate"
        [readOnly]="true"
        [type]="'text'"
        [value]="data()?.locator_destination_barcode"
        (valueChange)="changeValue('locator_destination_barcode', $event)" />
      <iu-storekeeper-input
        [label]="'Pallet' | SKWTranslate"
        [readOnly]="true"
        [type]="'text'"
        [value]="data()?.palette_destination_barcode"
        (valueChange)="changeValue('palette_destination_barcode', $event)" />
    </div>
  </div>
} @else if (canConvertToConditioning()) {
  <iu-storekeeper-button [label]="'ConvertToConditioning' | SKWTranslate" (click)="togglePalletPanel($event)" />
}
